import React, { createContext, useContext, useMemo, useRef } from "react";
import { ActiveContextProvider, useActiveContext } from "../state";
import { createFoundationRuntime } from "./createFoundationRuntime";

const FoundationRuntimeContext = createContext(null);

const FoundationRuntimeProvider = ({ children }) => {
  const runtimeRef = useRef(null);

  if (!runtimeRef.current) {
    runtimeRef.current = createFoundationRuntime();
  }

  return (
    <FoundationRuntimeContext.Provider value={runtimeRef.current}>
      {children}
    </FoundationRuntimeContext.Provider>
  );
};

const FoundationContextComposer = ({ children }) => {
  const runtime = useContext(FoundationRuntimeContext);
  const activeContext = useActiveContext();

  const value = useMemo(
    () => ({
      ...runtime,
      activeContext,
    }),
    [runtime, activeContext]
  );

  return (
    <FoundationRuntimeContext.Provider value={value}>
      {children}
    </FoundationRuntimeContext.Provider>
  );
};

export const FoundationProvider = ({ children }) => (
  <FoundationRuntimeProvider>
    <ActiveContextProvider>
      <FoundationContextComposer>{children}</FoundationContextComposer>
    </ActiveContextProvider>
  </FoundationRuntimeProvider>
);

export const useFoundation = () => {
  const context = useContext(FoundationRuntimeContext);

  if (!context) {
    throw new Error("useFoundation must be used within FoundationProvider");
  }

  return context;
};
